import React from 'react';
import { SectionShell, SectionTitle } from '../SectionShell';
import { CTAButton } from '../CTAButton';
import { alsoReceive } from '../../data/content';
export function AlsoReceive() {
  return <SectionShell data-id="element-76" data-mp="t316zthecj3h">
      <SectionTitle eyebrow="📲 Included" title="You’ll also receive:" data-id="element-77" data-mp="t1gcg3v3105m" />

      <ul className="grid gap-3 sm:grid-cols-2" data-id="element-78" data-mp="y12my5jj02aq">
        {alsoReceive.map(item => <li key={item.title} className="rounded-xl border border-sky-400/15 bg-navy-800 p-4" data-id="element-79" data-mp="j4lcdgj5urp8">
            <span className="text-2xl leading-none" aria-hidden="true" data-id="element-80" data-mp="o3eob4isuana">
              {item.emoji}
            </span>
            <h3 className="mt-2 font-display text-base uppercase leading-tight text-white sm:text-lg" data-id="element-81" data-mp="a46smlluhknu">
              {item.title}
            </h3>
            <p className="mt-1.5 text-sm leading-relaxed text-sky-100/70" data-id="element-82" data-mp="f303s7dnszku">{item.text}</p>
          </li>)}
      </ul>

      <p className="mt-8 text-center font-display text-lg uppercase leading-snug text-gold-400 sm:text-xl" data-id="element-83" data-mp="29graay0oz3c2">
        Whatever TRT question you’re reviewing…
      </p>
      <p className="mt-2 text-center text-sm leading-relaxed text-sky-100/75" data-id="element-84" data-mp="2wvvlyhjjkhwp">
        You’ll have a visual system designed to help you find the pathway that matches the clinical
        scenario.
      </p>

      <div className="mt-7" data-id="element-85" data-mp="36mgilzfnnccz">
        <CTAButton label="Get the complete TRT Decision Deck™" subline="Currency converted automatically for your country" data-id="element-86" data-mp="31o5du347vs1m" />
      </div>
    </SectionShell>;
}